import React, { useEffect, useState } from 'react';
import categories from '../../content/MerchantLabel';
import { getCollaboratorsCard } from '../../api/Public/collaborators';
import CollaboratorsCard from '../ui/CollaboratorsCard/CollaboratorsCard';

import styles from './MerchantType.module.css';

const MerchantType = ({ index }) => {
    const category = categories[index];
    const [empty, setEmpty] = useState(true);
    const [traderCard, setTraderCard]= useState([]);

    useEffect(() => {
        async function fetchSample() {
            const result = await getCollaboratorsCard({ category: index });
            const traders = result.data;

            if (traders && traders.length > 0) {
                const shuffled = [...traders].sort(() => Math.random() - 0.5);
                setTraderCard(shuffled);
                setEmpty(false);
            } else {
                setTraderCard([]);
                setEmpty(true);
            }
        }
        fetchSample();
    }, [index]);

    return (
        <div>
            <div className={styles.hero}>
                <h1 className={styles.title}>{category.name}: {category.title}</h1>
                <p className={styles.subtitle}>{category.description}</p>
            </div>
            <div className={styles.layout}>
                {empty ? (
                    <h1 className={styles.defaultTitle}>Pas de collaborateurs pour le moment</h1>
                ) : (
                    traderCard.map((t) => (
                        <CollaboratorsCard
                            key={t.id}
                            id={t.id}
                            company={t.company}
                            address={t.address}
                        />
                    ))
                )}
            </div>
        </div>
    );
};

export default MerchantType;